import { Box, Button, Divider, Flex, rem, Text, TextProps, Title } from "@mantine/core"
import { useMediaQuery, useWindowScroll } from "@mantine/hooks"
import CheveronUpIcon from "common/icons/cheveron-up"
import Image from "next/image"
import Link from "next/link"
import { FC } from "react"
import { IFooter } from "rules/interface/config/config.interface"
import FooterContactItem from "./contact-item"
import Namads from "./namads"
import SocialLinks from "./social-links"




const Footer: FC<IFooter> = ({ }) => {
    const mobileMatches = useMediaQuery('(max-width: 768px)')

    const [_, scrollTo] = useWindowScroll();


    const contentProps: TextProps = {
        fw: 500,
        c: "white",
        fz: { base: rem(14), sm: rem(20) },
        lh: { base: rem(40), sm: rem(28) },
    }


    return (
        <Box bg="blue.1" className="IRANSans">
            <Flex direction="column" className="container" py={{ base: "16px 120px", sm: rem(55) }} gap={{ base: 20, sm: 40 }} pos="relative">
                <Flex align="center" justify="space-between" gap="md" direction={{ base: "column-reverse", sm: "row" }}>
                    <Flex align="center" w="100%" gap={{ base: rem(14), sm: rem(24) }}>
                        <Link href="/" className="lh-0">
                            <Image
                                src={"/images/logos/logo-pictogram.svg"}
                                alt="logo"
                                width={mobileMatches ? 24 : 38}
                                height={mobileMatches ? 28 : 43}
                                unoptimized
                            />
                        </Link>

                        <Link href="/" className="lh-0">
                            <Image
                                src={"/images/logos/logo-light.png"}
                                alt="logo"
                                objectFit="contain"
                                unoptimized
                                width={mobileMatches ? 177 : 274}
                                height={mobileMatches ? 27 : 42}
                            />
                        </Link>
                    </Flex>

                    <Button
                        color="#fff"
                        c="primary.1"
                        rightSection={<CheveronUpIcon color="var(--mantine-color-primary-1)" />}
                        miw="150"
                        w={{ base: "100%", sm: "auto" }}
                        onClick={() => scrollTo({ y: 0 })}
                        pos="relative"
                        className="z-1"
                    >
                        بازگشت به بالا
                    </Button>
                </Flex>

                <Box
                    pos="absolute"
                    top={{ base: 40, sm: 120 }}
                    left={0}
                >
                    <Image
                        src="/images/footer/country-map.png"
                        alt="نقاط تحت پوشش"
                        width={mobileMatches ? 300 : 550}
                        height={mobileMatches ? 220 : 405}
                    />
                </Box>

                <Text
                    {...contentProps}
                >
                    سلام ساختمان یک شرکت تخصصی برای معرفی کابینت ساز و نجار به کاربران در 11 استان کشور است.
                    <br />
                    دارای مجوز تاییدیه از پارک علم و فناوری خراسان
                </Text>

                <FooterContactItem
                    pos="relative"
                />

                <Flex
                    align="end"
                    justify="space-between"
                    gap={16}
                >
                    <Text
                        {...contentProps}
                    >
                        همین امروز به خانواده سلام ساختمان بپیوندید!
                    </Text>

                    <Flex
                        align="baseline"
                        justify={{ base: "center", sm: "end" }}
                        pos={{ base: "absolute", sm: "unset" }}
                        bottom={{ base: 32, sm: 0 }}
                        left={0}
                        right={0}
                        mx={{ base: "auto", sm: 0 }}
                    >
                        <Namads />
                    </Flex>
                </Flex>

                <Divider
                    color="#FFFFFF4D"
                />

                <Flex
                    align="center"
                    justify="center"
                    direction="column"
                    gap="lg"
                >
                    <Title
                        order={5}
                        fw={500}
                        fz={{ base: rem(14), sm: rem(14) }}
                        lh={rem(19)}
                        c="white"
                    >
                        ما را دنبال کنید
                    </Title>

                    <SocialLinks />
                </Flex>
            </Flex>
        </Box>
    )
}

export default Footer